module.exports = __webpack_public_path__ + "static/media/revision-large.d90b98bf.png";